import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { OrderTrackingRoutingModule } from './order-tracking-routing.module';
import { OrderTrackingComponent } from './order-tracking.component';

@NgModule({
  declarations: [OrderTrackingComponent],
  imports: [
    OrderTrackingRoutingModule,
    SharedModule.forRoot(),
  ],
  exports: [OrderTrackingComponent],
  providers: [],
})
export class OrderTrackingModule { }
